// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-v2 {
  --bg: #eef3f8;
  --surface: #ffffff;
  --surface-soft: #f4f8fc;
  --border: #d8e2ee;
  --ink: #0f172a;
  --muted: #5f6f86;
  --accent: #dbeafe;
  --accent-strong: #2563eb;
  --success: #15803d;
  --warning: #b45309;
  --danger: #b91c1c;
  --shadow: 0 2px 9px rgba(15, 23, 42, 0.08), 0 10px 28px rgba(15, 23, 42, 0.06);
  --radius-sm: 8px;
  --radius-md: 10px;
  --radius-lg: 14px;
  background: linear-gradient(180deg, #f6f9fd 0%, #eef3f8 50%, #e8eef7 100%);
}

.portal-v2 .app-shell__content {
  background: transparent;
}

.portal-v2 .sidebar {
  background: linear-gradient(180deg, #12347a 0%, #18459a 65%, #1f56bb 100%);
  color: #e9f1ff;
  border-right: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 6px 24px rgba(8, 24, 72, 0.35);
}

.portal-v2 .sidebar__brand,
.portal-v2 .sidebar__brand:hover {
  color: #ffffff;
  text-decoration: none;
}

.portal-v2 .brand-badge {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  box-shadow: none;
}

.portal-v2 .sidebar__toggle {
  border-color: rgba(255, 255, 255, 0.32);
  background: rgba(255, 255, 255, 0.12);
}

.portal-v2 .sidebar__toggle span {
  background: #ffffff;
}

.portal-v2 .sidebar__link {
  color: rgba(240, 246, 255, 0.92);
  border-color: transparent;
}

.portal-v2 .sidebar__link:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.2);
}

.portal-v2 .sidebar__link.active {
  background: #ffffff;
  color: #1e40af;
  border-color: rgba(255, 255, 255, 0.75);
  box-shadow: 0 8px 18px rgba(6, 20, 58, 0.22);
}

.portal-v2 .sidebar.collapsed .sidebar__link.active {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.portal-v2 .topbar {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #d9e4f2;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.portal-v2 .topbar__menu-btn,
.portal-v2 .topbar__help-icon,
.portal-v2 .pill,
.portal-v2 .dropdown,
.portal-v2 .topbar__icon {
  border-radius: 10px;
}

.portal-v2 .topbar__help-icon {
  background: #f1f6ff;
}

.portal-v2 .portal-v2-sidebar__top {
  margin-bottom: 6px;
}

.portal-v2 .portal-v2-nav-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: rgba(226, 236, 255, 0.7);
  padding: 10px 8px 6px;
}

.portal-v2 .portal-v2-topbar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
}

.portal-v2 .portal-v2-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.portal-v2 .portal-v2-search {
  width: min(480px, 100%);
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d6e2f2;
  background: #f8fbff;
  border-radius: 10px;
  padding: 8px 11px;
  color: #6a7d96;
}

.portal-v2 .portal-v2-search-icon {
  font-size: 14px;
  line-height: 1;
}

.portal-v2 .portal-v2-search input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  color: #20395f;
  font-size: 13px;
}

.portal-v2 .container {
  max-width: 1280px;
  padding: 24px;
}

.portal-v2 .dashboard-hero {
  border: 1px solid #d8e4f5;
  background: linear-gradient(130deg, #ffffff 0%, #f6f9ff 58%, #ecf3ff 100%);
}

.portal-v2 .dashboard-hero__tags .pill {
  background: #eaf1ff;
  border-color: #d2dff8;
  color: #1e3a8a;
}

.portal-v2 .dashboard-hero__tags .pill.active {
  background: #dbeafe;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.portal-v2 .card,
.portal-v2 .search-filters,
.portal-v2 .table-container,
.portal-v2 .chart-card,
.portal-v2 .pagination-card,
.portal-v2 .card--toolbar {
  border: 1px solid #dbe5f2;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.04);
}

.portal-v2 .card:hover,
.portal-v2 .job-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
}

.portal-v2 .btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #ffffff;
}

.portal-v2 .btn.secondary {
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  color: #ffffff;
}

.portal-v2 .btn.ghost {
  background: #ffffff;
  border: 1px solid #d7e2f1;
  color: #1f3d7a;
}

.portal-v2 .btn.ghost:hover {
  background: #f2f7ff;
  border-color: #b8cdf0;
}

.portal-v2 .alert {
  border-radius: 10px;
}

.portal-v2 .alert.warning {
  background: #fff7e6;
  border-color: #f7d8a1;
  color: #9a6500;
}

.portal-v2 .alert.error {
  background: #fff1f1;
  border-color: #f5c2c2;
  color: #b32828;
}

.portal-v2 .alert.success {
  background: #effaf2;
  border-color: #bde5c8;
  color: #146c3b;
}

.portal-v2 .table th {
  color: #55667f;
  background: #f7faff;
}

.portal-v2 .input,
.portal-v2 .select,
.portal-v2 textarea {
  border-color: #d7e2ef;
  background: #ffffff;
}

.portal-v2 .input:focus,
.portal-v2 .select:focus,
.portal-v2 textarea:focus {
  border-color: #5a8ce8;
  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.35);
}

.portal-v2 .status-pill,
.portal-v2 .badge,
.portal-v2 .skill-tag {
  border-radius: 999px;
}

.portal-v2 .status-pill--green,
.portal-v2 .badge.green {
  background: #e8f8ee;
  color: #166534;
}

.portal-v2 .status-pill--yellow,
.portal-v2 .badge.yellow {
  background: #fff7df;
  color: #9a6700;
}

.portal-v2 .status-pill--red,
.portal-v2 .badge.red {
  background: #feecec;
  color: #b91c1c;
}

.portal-v2 .status-pill--gray,
.portal-v2 .badge.gray {
  background: #eef3f8;
  color: #5f6d82;
}

.portal-v2 .dropdown {
  border-color: #d8e4f2;
}

.portal-v2 .dropdown__title {
  color: #1f3354;
}

.portal-v2 .notif__message {
  color: #63758f;
}

.portal-v2 .resume-reminder-banner {
  padding-top: 16px;
}

.portal-v2 .page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 18px;
}

.portal-v2 .page-header h1 {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.3px;
  margin-bottom: 4px;
}

.portal-v2 .page-header p {
  color: #62748d;
}

.portal-v2 .recruiter-page-header {
  background: linear-gradient(130deg, #ffffff 0%, #f5f9ff 50%, #edf4ff 100%);
  border: 1px solid #d7e4f6;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.06);
}

.portal-v2 .recruiter-page-header__hint {
  background: #e8f1ff;
  color: #1f4daa;
  border: 1px solid #bfd8ff;
  border-radius: 999px;
  padding: 4px 10px;
}

.portal-v2 .filters-section {
  background: #ffffff;
  border: 1px solid #dbe6f4;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 16px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
}

.portal-v2 .filters-grid {
  gap: 12px;
}

.portal-v2 .filter-group .label {
  color: #334767;
  font-weight: 700;
}

.portal-v2 .filters-actions {
  border-top: 1px solid #e4ecf7;
  padding-top: 12px;
}

.portal-v2 .status-pill {
  border: 1px solid #d4e1f2;
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 11px;
  font-weight: 700;
}

.portal-v2 .status-pill--green {
  background: #eaf9ee;
  color: #166534;
  border-color: #bee4c8;
}

.portal-v2 .status-pill--yellow {
  background: #fff7e2;
  color: #9a6700;
  border-color: #f2dca1;
}

.portal-v2 .status-pill--red {
  background: #ffefef;
  color: #b91c1c;
  border-color: #f2c7c7;
}

.portal-v2 .status-pill--blue {
  background: #e8f1ff;
  color: #1d4ed8;
  border-color: #bfd4ff;
}

.portal-v2 .status-pill--gray {
  background: #eef3f8;
  color: #5f6d82;
  border-color: #d8e1ec;
}

.portal-v2 .application-list {
  gap: 14px;
}

.portal-v2 .application-card {
  border: 1px solid #dbe6f4;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
}

.portal-v2 .application-card__header {
  border-bottom: 1px solid #e5edf8;
  padding-bottom: 10px;
}

.portal-v2 .application-card__meta,
.portal-v2 .application-card__detail,
.portal-v2 .application-card__cover-letter,
.portal-v2 .application-card__links a {
  color: #5f7088;
}

.portal-v2 .application-card__links a:hover {
  color: #1e4fb0;
}

.portal-v2 .chart-card__header {
  border-bottom: 1px solid #e8eef7;
  padding-bottom: 10px;
}

.portal-v2 .chart-toggle {
  background: #f2f7ff;
  border-color: #d8e4f6;
}

.portal-v2 .bar-chart__bar {
  background: linear-gradient(180deg, #60a5fa 0%, #2563eb 100%);
}

.portal-v2 .pie-chart__viz {
  box-shadow: inset 0 0 0 8px #f7faff;
}

.portal-v2 .company-list__item {
  border-bottom: 1px solid #e7eef8;
  padding: 10px 0;
}

.portal-v2 .company-list__bar {
  background: #e8f0fb;
}

.portal-v2 .company-list__bar-fill {
  background: linear-gradient(90deg, #60a5fa, #2563eb);
}

.portal-v2 .job-manage-card {
  border: 1px solid #dce6f5;
  border-left: 4px solid #3b82f6;
  background: #ffffff;
}

.portal-v2 .job-manage-card__meta,
.portal-v2 .job-manage-card__meta--secondary,
.portal-v2 .job-manage-card__description {
  color: #61738c;
}

.portal-v2 .pagination-card {
  border: 1px solid #dbe5f2;
  background: #ffffff;
}

.portal-v2 .pagination button {
  border-color: #d0def1;
  background: #ffffff;
  color: #294778;
}

.portal-v2 .pagination button.active,
.portal-v2 .pagination button:hover:not(:disabled) {
  background: #e2edff;
  border-color: #9ec0ff;
  color: #1e4fb0;
}

.portal-v2 .table-container {
  border: 1px solid #dbe6f4;
}

.portal-v2 .users-table th,
.portal-v2 .jobs-table th,
.portal-v2 .table th {
  background: #f7faff;
  color: #566984;
}

.portal-v2 .users-table td,
.portal-v2 .jobs-table td,
.portal-v2 .table td {
  border-bottom-color: #e7eef8;
}

.portal-v2 .skill-tag {
  background: #edf3ff;
  border-color: #cfe0fb;
  color: #1f4daa;
}

.portal-v2 .empty-state,
.portal-v2 .card--empty .muted,
.portal-v2 .card--narrow .muted {
  color: #61738c;
}

.portal-v2 .footer {
  background: rgba(255, 255, 255, 0.9);
  border-top: 1px solid #dce6f4;
}

.portal-v2 .talent-filters-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.portal-v2 .talent-results {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.portal-v2 .talent-card {
  border-left: 4px solid #5b89e4;
}

.portal-v2 .talent-card__header {
  margin-bottom: 6px;
}

.portal-v2 .talent-card__title {
  margin: 0;
}

.portal-v2 .talent-card__partner-pill {
  margin-left: 8px;
}

.portal-v2 .talent-card__line {
  margin: 0 0 8px;
}

.portal-v2 .talent-card__skills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.portal-v2 .talent-card__hint {
  margin-top: 10px;
  font-style: italic;
}

.portal-v2 .talent-card__actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .pagination-card__summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 12px;
}

.portal-v2 .pagination-card__count {
  margin: 0;
}

.portal-v2 .pagination-card__per-page {
  display: flex;
  align-items: center;
  gap: 8px;
}

.portal-v2 .pagination-card__controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.portal-v2 .recruiter-buckets-create {
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.portal-v2 .recruiter-buckets-create .input {
  flex: 1 1;
}

.portal-v2 .recruiter-buckets-list,
.portal-v2 .recruiter-buckets-profiles {
  display: grid;
  gap: 8px;
}

.portal-v2 .recruiter-buckets-profile-card,
.portal-v2 .recruiter-buckets-detail-card {
  padding: 12px;
}

.portal-v2 .recruiter-buckets-profile-head {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.portal-v2 .recruiter-buckets-meta {
  font-size: 12px;
}

.portal-v2 .recruiter-buckets-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .recruiter-buckets-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.portal-v2 .recruiter-buckets-modal {
  width: min(900px, 100%);
  max-height: 88vh;
  overflow: auto;
}

.portal-v2 .recruiter-buckets-modal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.portal-v2 .recruiter-buckets-modal-title,
.portal-v2 .recruiter-buckets-subtitle {
  margin-top: 0;
}

.portal-v2 .recruiter-buckets-modal-body,
.portal-v2 .recruiter-buckets-snapshot,
.portal-v2 .recruiter-buckets-version-list {
  display: grid;
  gap: 12px;
}

.portal-v2 .recruiter-buckets-version-item {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .jobs-page-header {
  margin-bottom: 24px;
}

.portal-v2 .jobs-company-suggestions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow);
  max-height: 220px;
  overflow-y: auto;
}

.portal-v2 .jobs-company-suggestions .btn-link {
  border-radius: 0;
  color: var(--ink);
  text-decoration: none;
  border-bottom: 1px solid var(--border);
}

.portal-v2 .jobs-results-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 12px;
  flex-wrap: wrap;
}

.portal-v2 .jobs-results-count {
  margin: 0;
}

.portal-v2 .jobs-results-page-size {
  display: flex;
  align-items: center;
  gap: 8px;
}

.portal-v2 .jobs-results-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.portal-v2 .job-detail-layout {
  align-items: start;
}

.portal-v2 .job-detail-main {
  grid-column: span 2;
}

.portal-v2 .job-detail-section {
  margin-bottom: 24px;
}

.portal-v2 .job-detail-meta {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 8px;
  flex-wrap: wrap;
}

.portal-v2 .job-detail-salary {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1d4ed8;
}

.portal-v2 .job-detail-text {
  white-space: pre-line;
  line-height: 1.6;
}

.portal-v2 .job-detail-sidebar .btn {
  margin-bottom: 10px;
}

.portal-v2 .job-detail-file-meta {
  margin-top: 6px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.portal-v2 .job-detail-action-row {
  display: flex;
  gap: 8px;
}

.portal-v2 .job-detail-share-actions {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.portal-v2 .job-detail-stats {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #d8e5f7;
}

.portal-v2 .job-detail-stats-list {
  margin-top: 12px;
}

.portal-v2 .job-detail-stats-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.portal-v2 .pricing-affiliate-alert {
  margin-bottom: 12px;
}

.portal-v2 .help-card {
  margin-bottom: 16px;
}

.portal-v2 .help-form {
  display: grid;
  gap: 12px;
}

.portal-v2 .help-form-files {
  margin-top: 6px;
  font-size: 12px;
}

.portal-v2 .help-ticket-attachments {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.portal-v2 .help-published-list {
  display: grid;
  gap: 10px;
}

.portal-v2 .help-published-item {
  padding: 12px;
}

.portal-v2 .help-published-head {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .help-published-date {
  font-size: 12px;
}

.portal-v2 .help-published-body,
.portal-v2 .help-published-admin {
  margin: 6px 0 0;
}

.portal-v2 .candidate-profile-view-hero {
  display: flex;
  gap: 16px;
  align-items: center;
}

.portal-v2 .candidate-profile-view-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-view-actions {
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-view-card {
  margin-bottom: 16px;
}

.portal-v2 .candidate-profile-view-grid {
  display: grid;
  gap: 6px;
}

.portal-v2 .candidate-profile-view-skills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.portal-v2 .candidate-profile-view-cover-note,
.portal-v2 .candidate-profile-view-item-note {
  margin-top: 4px;
}

.portal-v2 .candidate-profile-view-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portal-v2 .recruiter-profile-header-card {
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.portal-v2 .recruiter-profile-header-main {
  display: flex;
  gap: 12px;
  align-items: center;
}

.portal-v2 .recruiter-profile-title {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .recruiter-profile-photo-name {
  font-size: 12px;
}

.portal-v2 .recruiter-profile-header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.portal-v2 .recruiter-profile-completeness-card {
  margin-bottom: 16px;
}

.portal-v2 .recruiter-profile-completeness-title {
  margin: 0;
}

.portal-v2 .recruiter-profile-completeness-note {
  margin-top: 8px;
  font-size: 13px;
}

.portal-v2 .recruiter-profile-section-card {
  margin-bottom: 24px;
}

.portal-v2 .recruiter-profile-form-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.portal-v2 .recruiter-profile-grid {
  gap: 16px;
}

.portal-v2 .recruiter-profile-email-label {
  margin-bottom: 4px;
}

.portal-v2 .recruiter-profile-email-value {
  background: #0f172a;
  border-style: dashed;
  color: #f8fafc;
}

.portal-v2 .recruiter-profile-tenure {
  margin-top: 4px;
}

.portal-v2 .recruiter-profile-messages,
.portal-v2 .recruiter-profile-paused-alert {
  margin-bottom: 24px;
}

.portal-v2 .recruiter-profile-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.portal-v2 .dashboard-welcome-title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-notfound-card {
  text-align: center;
  max-width: 400px;
}

.portal-v2 .candidate-profile-header-card {
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-header-main {
  display: flex;
  gap: 16px;
  align-items: center;
}

.portal-v2 .candidate-profile-title {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-photo-name {
  font-size: 12px;
}

.portal-v2 .candidate-profile-header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.portal-v2 .candidate-profile-completeness-card {
  margin-bottom: 16px;
}

.portal-v2 .candidate-profile-completeness-title {
  margin: 0;
}

.portal-v2 .candidate-profile-completeness-note {
  margin-top: 8px;
  font-size: 13px;
}

.portal-v2 .candidate-profile-layout {
  gap: 24px;
  align-items: start;
}

.portal-v2 .candidate-profile-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.portal-v2 .candidate-profile-grid {
  gap: 16px;
}

.portal-v2 .candidate-profile-grid--mt {
  margin-top: 16px;
}

.portal-v2 .candidate-profile-grid-span-full {
  grid-column: 1 / -1;
}

.portal-v2 .candidate-profile-helptext {
  font-size: 12px;
  margin-top: 4px;
}

.portal-v2 .candidate-profile-inline-checkbox {
  display: flex;
  align-items: center;
}

.portal-v2 .candidate-profile-inline-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.portal-v2 .candidate-profile-currency-input-wrap {
  position: relative;
}

.portal-v2 .candidate-profile-currency-prefix {
  position: absolute;
  left: 12px;
  top: 12px;
  color: var(--muted);
  font-weight: 600;
}

.portal-v2 .candidate-profile-input-with-prefix {
  padding-left: 60px;
}

.portal-v2 .candidate-profile-collapse-btn {
  font-size: 14px;
  padding: 8px 12px;
}

.portal-v2 .candidate-profile-textarea-sm {
  min-height: 80px;
  resize: vertical;
}

.portal-v2 .candidate-profile-textarea-md {
  min-height: 120px;
  resize: vertical;
}

.portal-v2 .candidate-profile-textarea-lg {
  min-height: 150px;
  resize: vertical;
}

.portal-v2 .candidate-profile-form-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.portal-v2 .candidate-profile-form-stack--mt {
  margin-top: 16px;
}

.portal-v2 .candidate-profile-badge-current {
  margin: 16px 0;
  display: inline-block;
}

.portal-v2 .candidate-profile-block--mt {
  margin-top: 16px;
}

.portal-v2 .candidate-profile-upload-dropzone {
  border: 2px dashed #9eb1cc;
  text-align: center;
  padding: 32px 16px;
  margin-top: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.portal-v2 .candidate-profile-upload-label {
  cursor: pointer;
  width: 100%;
  display: block;
}

.portal-v2 .candidate-profile-upload-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.portal-v2 .candidate-profile-upload-copy {
  margin: 0 0 8px;
  color: var(--ink);
}

.portal-v2 .candidate-profile-upload-accent {
  color: #1d4ed8;
  font-weight: 700;
}

.portal-v2 .candidate-profile-upload-meta {
  font-size: 12px;
  margin: 0;
}

.portal-v2 .candidate-profile-upload-selected {
  margin-top: 16px;
  background-color: rgba(96, 165, 250, 0.12);
  border: 1px solid rgba(96, 165, 250, 0.35);
}

.portal-v2 .candidate-profile-upload-selected-copy {
  margin: 0 0 12px;
  color: #1d4ed8;
}

.portal-v2 .candidate-profile-button-full {
  width: 100%;
}

.portal-v2 .candidate-profile-spinner-sm {
  width: 16px;
  height: 16px;
}

.portal-v2 .candidate-profile-section-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.portal-v2 .candidate-profile-entry-card {
  margin-bottom: 12px;
  background-color: rgba(255, 255, 255, 0.4);
}

.portal-v2 .candidate-profile-entry-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portal-v2 .candidate-profile-entry-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-entry-col {
  flex: 1 1;
  min-width: 140px;
}

.portal-v2 .candidate-profile-action-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-entry-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.portal-v2 .candidate-profile-entry-content {
  flex: 1 1;
}

.portal-v2 .candidate-profile-entry-title {
  font-weight: 700;
}

.portal-v2 .candidate-profile-meta-xs {
  font-size: 12px;
}

.portal-v2 .candidate-profile-entry-desc {
  margin-top: 4px;
  white-space: pre-line;
}

.portal-v2 .candidate-profile-btn-xs {
  font-size: 12px;
  padding: 4px 8px;
}

.portal-v2 .candidate-profile-btn-danger {
  color: #dc2626;
}

.portal-v2 .candidate-profile-entry-add {
  background-color: rgba(96, 165, 250, 0.12);
  border: 1px solid rgba(96, 165, 250, 0.35);
}

.portal-v2 .candidate-profile-inline-label-muted {
  font-size: 14px;
  color: var(--muted);
}

.portal-v2 .candidate-profile-skill-card {
  margin-bottom: 8px;
  background-color: rgba(255, 255, 255, 0.4);
}

.portal-v2 .candidate-profile-skill-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.portal-v2 .candidate-profile-inline-meta {
  margin-left: 8px;
  font-size: 12px;
}

.portal-v2 .candidate-profile-link-wrap {
  margin-top: 4px;
}

.portal-v2 .candidate-profile-link-xs {
  font-size: 12px;
}

.portal-v2 .candidate-profile-button-lg {
  width: 100%;
  font-size: 16px;
  padding: 14px;
}

.portal-v2 .candidate-profile-block--mb {
  margin-bottom: 12px;
}

.portal-v2 .candidate-profile-badge-inline {
  margin: 8px 0;
  display: inline-block;
}

.portal-v2 .candidate-profile-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.portal-v2 .candidate-profile-file-selected {
  display: flex;
  align-items: center;
  gap: 10px;
}

@media (max-width: 960px) {
  .portal-v2 .topbar {
    padding: 10px 12px;
  }

  .portal-v2 .portal-v2-topbar {
    grid-template-columns: auto 1fr auto;
    gap: 8px;
  }

  .portal-v2 .portal-v2-search {
    padding: 7px 9px;
  }

  .portal-v2 .sidebar {
    box-shadow: 0 12px 30px rgba(8, 24, 72, 0.5);
  }

  .portal-v2 .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .portal-v2 .pagination-card__controls {
    flex-direction: column;
    align-items: stretch;
  }

  .portal-v2 .job-detail-main {
    grid-column: span 3;
  }

  .portal-v2 .job-detail-action-row {
    flex-direction: column;
  }

  .portal-v2 .candidate-profile-view-hero {
    align-items: flex-start;
  }

  .portal-v2 .candidate-profile-layout {
    gap: 16px;
  }

  .portal-v2 .candidate-profile-entry-head,
  .portal-v2 .candidate-profile-skill-row {
    flex-direction: column;
    align-items: flex-start;
  }
}

.portal-v2 .sidebar__group-header {
  color: var(--portal-muted, #64748b);
}

.portal-v2 .sidebar__group-header:hover {
  background: var(--portal-surface-2, rgba(15, 23, 42, 0.04));
  color: var(--portal-ink, #0f172a);
}
`, "",{"version":3,"sources":["webpack://./src/styles.portalV2.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,8EAA8E;EAC9E,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,0EAA0E;AAC5E;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0EAA0E;EAC1E,cAAc;EACd,iDAAiD;EACjD,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0EAA0E;AAC5E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;;EAME,yBAAyB;EACzB,gFAAgF;AAClF;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;EAC3D,iCAAiC;AACnC","sourcesContent":[".portal-v2 {\n  --bg: #eef3f8;\n  --surface: #ffffff;\n  --surface-soft: #f4f8fc;\n  --border: #d8e2ee;\n  --ink: #0f172a;\n  --muted: #5f6f86;\n  --accent: #dbeafe;\n  --accent-strong: #2563eb;\n  --success: #15803d;\n  --warning: #b45309;\n  --danger: #b91c1c;\n  --shadow: 0 2px 9px rgba(15, 23, 42, 0.08), 0 10px 28px rgba(15, 23, 42, 0.06);\n  --radius-sm: 8px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  background: linear-gradient(180deg, #f6f9fd 0%, #eef3f8 50%, #e8eef7 100%);\n}\n\n.portal-v2 .app-shell__content {\n  background: transparent;\n}\n\n.portal-v2 .sidebar {\n  background: linear-gradient(180deg, #12347a 0%, #18459a 65%, #1f56bb 100%);\n  color: #e9f1ff;\n  border-right: 1px solid rgba(255, 255, 255, 0.16);\n  box-shadow: 0 6px 24px rgba(8, 24, 72, 0.35);\n}\n\n.portal-v2 .sidebar__brand,\n.portal-v2 .sidebar__brand:hover {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.portal-v2 .brand-badge {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  box-shadow: none;\n}\n\n.portal-v2 .sidebar__toggle {\n  border-color: rgba(255, 255, 255, 0.32);\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.portal-v2 .sidebar__toggle span {\n  background: #ffffff;\n}\n\n.portal-v2 .sidebar__link {\n  color: rgba(240, 246, 255, 0.92);\n  border-color: transparent;\n}\n\n.portal-v2 .sidebar__link:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.portal-v2 .sidebar__link.active {\n  background: #ffffff;\n  color: #1e40af;\n  border-color: rgba(255, 255, 255, 0.75);\n  box-shadow: 0 8px 18px rgba(6, 20, 58, 0.22);\n}\n\n.portal-v2 .sidebar.collapsed .sidebar__link.active {\n  background: rgba(255, 255, 255, 0.16);\n  color: #ffffff;\n}\n\n.portal-v2 .topbar {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid #d9e4f2;\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);\n}\n\n.portal-v2 .topbar__menu-btn,\n.portal-v2 .topbar__help-icon,\n.portal-v2 .pill,\n.portal-v2 .dropdown,\n.portal-v2 .topbar__icon {\n  border-radius: 10px;\n}\n\n.portal-v2 .topbar__help-icon {\n  background: #f1f6ff;\n}\n\n.portal-v2 .portal-v2-sidebar__top {\n  margin-bottom: 6px;\n}\n\n.portal-v2 .portal-v2-nav-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: rgba(226, 236, 255, 0.7);\n  padding: 10px 8px 6px;\n}\n\n.portal-v2 .portal-v2-topbar {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 12px;\n}\n\n.portal-v2 .portal-v2-header-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n}\n\n.portal-v2 .portal-v2-search {\n  width: min(480px, 100%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #d6e2f2;\n  background: #f8fbff;\n  border-radius: 10px;\n  padding: 8px 11px;\n  color: #6a7d96;\n}\n\n.portal-v2 .portal-v2-search-icon {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.portal-v2 .portal-v2-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  color: #20395f;\n  font-size: 13px;\n}\n\n.portal-v2 .container {\n  max-width: 1280px;\n  padding: 24px;\n}\n\n.portal-v2 .dashboard-hero {\n  border: 1px solid #d8e4f5;\n  background: linear-gradient(130deg, #ffffff 0%, #f6f9ff 58%, #ecf3ff 100%);\n}\n\n.portal-v2 .dashboard-hero__tags .pill {\n  background: #eaf1ff;\n  border-color: #d2dff8;\n  color: #1e3a8a;\n}\n\n.portal-v2 .dashboard-hero__tags .pill.active {\n  background: #dbeafe;\n  border-color: #93c5fd;\n  color: #1d4ed8;\n}\n\n.portal-v2 .card,\n.portal-v2 .search-filters,\n.portal-v2 .table-container,\n.portal-v2 .chart-card,\n.portal-v2 .pagination-card,\n.portal-v2 .card--toolbar {\n  border: 1px solid #dbe5f2;\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.04);\n}\n\n.portal-v2 .card:hover,\n.portal-v2 .job-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);\n}\n\n.portal-v2 .btn {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #ffffff;\n}\n\n.portal-v2 .btn.secondary {\n  background: linear-gradient(135deg, #60a5fa, #3b82f6);\n  color: #ffffff;\n}\n\n.portal-v2 .btn.ghost {\n  background: #ffffff;\n  border: 1px solid #d7e2f1;\n  color: #1f3d7a;\n}\n\n.portal-v2 .btn.ghost:hover {\n  background: #f2f7ff;\n  border-color: #b8cdf0;\n}\n\n.portal-v2 .alert {\n  border-radius: 10px;\n}\n\n.portal-v2 .alert.warning {\n  background: #fff7e6;\n  border-color: #f7d8a1;\n  color: #9a6500;\n}\n\n.portal-v2 .alert.error {\n  background: #fff1f1;\n  border-color: #f5c2c2;\n  color: #b32828;\n}\n\n.portal-v2 .alert.success {\n  background: #effaf2;\n  border-color: #bde5c8;\n  color: #146c3b;\n}\n\n.portal-v2 .table th {\n  color: #55667f;\n  background: #f7faff;\n}\n\n.portal-v2 .input,\n.portal-v2 .select,\n.portal-v2 textarea {\n  border-color: #d7e2ef;\n  background: #ffffff;\n}\n\n.portal-v2 .input:focus,\n.portal-v2 .select:focus,\n.portal-v2 textarea:focus {\n  border-color: #5a8ce8;\n  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.35);\n}\n\n.portal-v2 .status-pill,\n.portal-v2 .badge,\n.portal-v2 .skill-tag {\n  border-radius: 999px;\n}\n\n.portal-v2 .status-pill--green,\n.portal-v2 .badge.green {\n  background: #e8f8ee;\n  color: #166534;\n}\n\n.portal-v2 .status-pill--yellow,\n.portal-v2 .badge.yellow {\n  background: #fff7df;\n  color: #9a6700;\n}\n\n.portal-v2 .status-pill--red,\n.portal-v2 .badge.red {\n  background: #feecec;\n  color: #b91c1c;\n}\n\n.portal-v2 .status-pill--gray,\n.portal-v2 .badge.gray {\n  background: #eef3f8;\n  color: #5f6d82;\n}\n\n.portal-v2 .dropdown {\n  border-color: #d8e4f2;\n}\n\n.portal-v2 .dropdown__title {\n  color: #1f3354;\n}\n\n.portal-v2 .notif__message {\n  color: #63758f;\n}\n\n.portal-v2 .resume-reminder-banner {\n  padding-top: 16px;\n}\n\n.portal-v2 .page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.portal-v2 .page-header h1 {\n  font-size: 24px;\n  font-weight: 800;\n  letter-spacing: -0.3px;\n  margin-bottom: 4px;\n}\n\n.portal-v2 .page-header p {\n  color: #62748d;\n}\n\n.portal-v2 .recruiter-page-header {\n  background: linear-gradient(130deg, #ffffff 0%, #f5f9ff 50%, #edf4ff 100%);\n  border: 1px solid #d7e4f6;\n  border-radius: 14px;\n  padding: 16px 18px;\n  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.06);\n}\n\n.portal-v2 .recruiter-page-header__hint {\n  background: #e8f1ff;\n  color: #1f4daa;\n  border: 1px solid #bfd8ff;\n  border-radius: 999px;\n  padding: 4px 10px;\n}\n\n.portal-v2 .filters-section {\n  background: #ffffff;\n  border: 1px solid #dbe6f4;\n  border-radius: 14px;\n  padding: 14px;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);\n}\n\n.portal-v2 .filters-grid {\n  gap: 12px;\n}\n\n.portal-v2 .filter-group .label {\n  color: #334767;\n  font-weight: 700;\n}\n\n.portal-v2 .filters-actions {\n  border-top: 1px solid #e4ecf7;\n  padding-top: 12px;\n}\n\n.portal-v2 .status-pill {\n  border: 1px solid #d4e1f2;\n  border-radius: 999px;\n  padding: 3px 9px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.portal-v2 .status-pill--green {\n  background: #eaf9ee;\n  color: #166534;\n  border-color: #bee4c8;\n}\n\n.portal-v2 .status-pill--yellow {\n  background: #fff7e2;\n  color: #9a6700;\n  border-color: #f2dca1;\n}\n\n.portal-v2 .status-pill--red {\n  background: #ffefef;\n  color: #b91c1c;\n  border-color: #f2c7c7;\n}\n\n.portal-v2 .status-pill--blue {\n  background: #e8f1ff;\n  color: #1d4ed8;\n  border-color: #bfd4ff;\n}\n\n.portal-v2 .status-pill--gray {\n  background: #eef3f8;\n  color: #5f6d82;\n  border-color: #d8e1ec;\n}\n\n.portal-v2 .application-list {\n  gap: 14px;\n}\n\n.portal-v2 .application-card {\n  border: 1px solid #dbe6f4;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);\n}\n\n.portal-v2 .application-card__header {\n  border-bottom: 1px solid #e5edf8;\n  padding-bottom: 10px;\n}\n\n.portal-v2 .application-card__meta,\n.portal-v2 .application-card__detail,\n.portal-v2 .application-card__cover-letter,\n.portal-v2 .application-card__links a {\n  color: #5f7088;\n}\n\n.portal-v2 .application-card__links a:hover {\n  color: #1e4fb0;\n}\n\n.portal-v2 .chart-card__header {\n  border-bottom: 1px solid #e8eef7;\n  padding-bottom: 10px;\n}\n\n.portal-v2 .chart-toggle {\n  background: #f2f7ff;\n  border-color: #d8e4f6;\n}\n\n.portal-v2 .bar-chart__bar {\n  background: linear-gradient(180deg, #60a5fa 0%, #2563eb 100%);\n}\n\n.portal-v2 .pie-chart__viz {\n  box-shadow: inset 0 0 0 8px #f7faff;\n}\n\n.portal-v2 .company-list__item {\n  border-bottom: 1px solid #e7eef8;\n  padding: 10px 0;\n}\n\n.portal-v2 .company-list__bar {\n  background: #e8f0fb;\n}\n\n.portal-v2 .company-list__bar-fill {\n  background: linear-gradient(90deg, #60a5fa, #2563eb);\n}\n\n.portal-v2 .job-manage-card {\n  border: 1px solid #dce6f5;\n  border-left: 4px solid #3b82f6;\n  background: #ffffff;\n}\n\n.portal-v2 .job-manage-card__meta,\n.portal-v2 .job-manage-card__meta--secondary,\n.portal-v2 .job-manage-card__description {\n  color: #61738c;\n}\n\n.portal-v2 .pagination-card {\n  border: 1px solid #dbe5f2;\n  background: #ffffff;\n}\n\n.portal-v2 .pagination button {\n  border-color: #d0def1;\n  background: #ffffff;\n  color: #294778;\n}\n\n.portal-v2 .pagination button.active,\n.portal-v2 .pagination button:hover:not(:disabled) {\n  background: #e2edff;\n  border-color: #9ec0ff;\n  color: #1e4fb0;\n}\n\n.portal-v2 .table-container {\n  border: 1px solid #dbe6f4;\n}\n\n.portal-v2 .users-table th,\n.portal-v2 .jobs-table th,\n.portal-v2 .table th {\n  background: #f7faff;\n  color: #566984;\n}\n\n.portal-v2 .users-table td,\n.portal-v2 .jobs-table td,\n.portal-v2 .table td {\n  border-bottom-color: #e7eef8;\n}\n\n.portal-v2 .skill-tag {\n  background: #edf3ff;\n  border-color: #cfe0fb;\n  color: #1f4daa;\n}\n\n.portal-v2 .empty-state,\n.portal-v2 .card--empty .muted,\n.portal-v2 .card--narrow .muted {\n  color: #61738c;\n}\n\n.portal-v2 .footer {\n  background: rgba(255, 255, 255, 0.9);\n  border-top: 1px solid #dce6f4;\n}\n\n.portal-v2 .talent-filters-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n}\n\n.portal-v2 .talent-results {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.portal-v2 .talent-card {\n  border-left: 4px solid #5b89e4;\n}\n\n.portal-v2 .talent-card__header {\n  margin-bottom: 6px;\n}\n\n.portal-v2 .talent-card__title {\n  margin: 0;\n}\n\n.portal-v2 .talent-card__partner-pill {\n  margin-left: 8px;\n}\n\n.portal-v2 .talent-card__line {\n  margin: 0 0 8px;\n}\n\n.portal-v2 .talent-card__skills {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.portal-v2 .talent-card__hint {\n  margin-top: 10px;\n  font-style: italic;\n}\n\n.portal-v2 .talent-card__actions {\n  margin-top: 12px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .pagination-card__summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.portal-v2 .pagination-card__count {\n  margin: 0;\n}\n\n.portal-v2 .pagination-card__per-page {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.portal-v2 .pagination-card__controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.portal-v2 .recruiter-buckets-create {\n  margin-bottom: 16px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .recruiter-buckets-create .input {\n  flex: 1;\n}\n\n.portal-v2 .recruiter-buckets-list,\n.portal-v2 .recruiter-buckets-profiles {\n  display: grid;\n  gap: 8px;\n}\n\n.portal-v2 .recruiter-buckets-profile-card,\n.portal-v2 .recruiter-buckets-detail-card {\n  padding: 12px;\n}\n\n.portal-v2 .recruiter-buckets-profile-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .recruiter-buckets-meta {\n  font-size: 12px;\n}\n\n.portal-v2 .recruiter-buckets-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .recruiter-buckets-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n}\n\n.portal-v2 .recruiter-buckets-modal {\n  width: min(900px, 100%);\n  max-height: 88vh;\n  overflow: auto;\n}\n\n.portal-v2 .recruiter-buckets-modal-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.portal-v2 .recruiter-buckets-modal-title,\n.portal-v2 .recruiter-buckets-subtitle {\n  margin-top: 0;\n}\n\n.portal-v2 .recruiter-buckets-modal-body,\n.portal-v2 .recruiter-buckets-snapshot,\n.portal-v2 .recruiter-buckets-version-list {\n  display: grid;\n  gap: 12px;\n}\n\n.portal-v2 .recruiter-buckets-version-item {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .jobs-page-header {\n  margin-bottom: 24px;\n}\n\n.portal-v2 .jobs-company-suggestions {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 20;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  box-shadow: var(--shadow);\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.portal-v2 .jobs-company-suggestions .btn-link {\n  border-radius: 0;\n  color: var(--ink);\n  text-decoration: none;\n  border-bottom: 1px solid var(--border);\n}\n\n.portal-v2 .jobs-results-summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .jobs-results-count {\n  margin: 0;\n}\n\n.portal-v2 .jobs-results-page-size {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.portal-v2 .jobs-results-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.portal-v2 .job-detail-layout {\n  align-items: start;\n}\n\n.portal-v2 .job-detail-main {\n  grid-column: span 2;\n}\n\n.portal-v2 .job-detail-section {\n  margin-bottom: 24px;\n}\n\n.portal-v2 .job-detail-meta {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .job-detail-salary {\n  margin-top: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1d4ed8;\n}\n\n.portal-v2 .job-detail-text {\n  white-space: pre-line;\n  line-height: 1.6;\n}\n\n.portal-v2 .job-detail-sidebar .btn {\n  margin-bottom: 10px;\n}\n\n.portal-v2 .job-detail-file-meta {\n  margin-top: 6px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.portal-v2 .job-detail-action-row {\n  display: flex;\n  gap: 8px;\n}\n\n.portal-v2 .job-detail-share-actions {\n  display: grid;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.portal-v2 .job-detail-stats {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid #d8e5f7;\n}\n\n.portal-v2 .job-detail-stats-list {\n  margin-top: 12px;\n}\n\n.portal-v2 .job-detail-stats-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.portal-v2 .pricing-affiliate-alert {\n  margin-bottom: 12px;\n}\n\n.portal-v2 .help-card {\n  margin-bottom: 16px;\n}\n\n.portal-v2 .help-form {\n  display: grid;\n  gap: 12px;\n}\n\n.portal-v2 .help-form-files {\n  margin-top: 6px;\n  font-size: 12px;\n}\n\n.portal-v2 .help-ticket-attachments {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .help-published-list {\n  display: grid;\n  gap: 10px;\n}\n\n.portal-v2 .help-published-item {\n  padding: 12px;\n}\n\n.portal-v2 .help-published-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .help-published-date {\n  font-size: 12px;\n}\n\n.portal-v2 .help-published-body,\n.portal-v2 .help-published-admin {\n  margin: 6px 0 0;\n}\n\n.portal-v2 .candidate-profile-view-hero {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.portal-v2 .candidate-profile-view-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-view-actions {\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-view-card {\n  margin-bottom: 16px;\n}\n\n.portal-v2 .candidate-profile-view-grid {\n  display: grid;\n  gap: 6px;\n}\n\n.portal-v2 .candidate-profile-view-skills {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.portal-v2 .candidate-profile-view-cover-note,\n.portal-v2 .candidate-profile-view-item-note {\n  margin-top: 4px;\n}\n\n.portal-v2 .candidate-profile-view-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.portal-v2 .recruiter-profile-header-card {\n  margin-bottom: 16px;\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .recruiter-profile-header-main {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.portal-v2 .recruiter-profile-title {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .recruiter-profile-photo-name {\n  font-size: 12px;\n}\n\n.portal-v2 .recruiter-profile-header-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.portal-v2 .recruiter-profile-completeness-card {\n  margin-bottom: 16px;\n}\n\n.portal-v2 .recruiter-profile-completeness-title {\n  margin: 0;\n}\n\n.portal-v2 .recruiter-profile-completeness-note {\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n.portal-v2 .recruiter-profile-section-card {\n  margin-bottom: 24px;\n}\n\n.portal-v2 .recruiter-profile-form-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.portal-v2 .recruiter-profile-grid {\n  gap: 16px;\n}\n\n.portal-v2 .recruiter-profile-email-label {\n  margin-bottom: 4px;\n}\n\n.portal-v2 .recruiter-profile-email-value {\n  background: #0f172a;\n  border-style: dashed;\n  color: #f8fafc;\n}\n\n.portal-v2 .recruiter-profile-tenure {\n  margin-top: 4px;\n}\n\n.portal-v2 .recruiter-profile-messages,\n.portal-v2 .recruiter-profile-paused-alert {\n  margin-bottom: 24px;\n}\n\n.portal-v2 .recruiter-profile-footer-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.portal-v2 .dashboard-welcome-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-notfound-card {\n  text-align: center;\n  max-width: 400px;\n}\n\n.portal-v2 .candidate-profile-header-card {\n  margin-bottom: 16px;\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-header-main {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.portal-v2 .candidate-profile-title {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-photo-name {\n  font-size: 12px;\n}\n\n.portal-v2 .candidate-profile-header-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.portal-v2 .candidate-profile-completeness-card {\n  margin-bottom: 16px;\n}\n\n.portal-v2 .candidate-profile-completeness-title {\n  margin: 0;\n}\n\n.portal-v2 .candidate-profile-completeness-note {\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n.portal-v2 .candidate-profile-layout {\n  gap: 24px;\n  align-items: start;\n}\n\n.portal-v2 .candidate-profile-column {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.portal-v2 .candidate-profile-grid {\n  gap: 16px;\n}\n\n.portal-v2 .candidate-profile-grid--mt {\n  margin-top: 16px;\n}\n\n.portal-v2 .candidate-profile-grid-span-full {\n  grid-column: 1 / -1;\n}\n\n.portal-v2 .candidate-profile-helptext {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.portal-v2 .candidate-profile-inline-checkbox {\n  display: flex;\n  align-items: center;\n}\n\n.portal-v2 .candidate-profile-inline-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n}\n\n.portal-v2 .candidate-profile-currency-input-wrap {\n  position: relative;\n}\n\n.portal-v2 .candidate-profile-currency-prefix {\n  position: absolute;\n  left: 12px;\n  top: 12px;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.portal-v2 .candidate-profile-input-with-prefix {\n  padding-left: 60px;\n}\n\n.portal-v2 .candidate-profile-collapse-btn {\n  font-size: 14px;\n  padding: 8px 12px;\n}\n\n.portal-v2 .candidate-profile-textarea-sm {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.portal-v2 .candidate-profile-textarea-md {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.portal-v2 .candidate-profile-textarea-lg {\n  min-height: 150px;\n  resize: vertical;\n}\n\n.portal-v2 .candidate-profile-form-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.portal-v2 .candidate-profile-form-stack--mt {\n  margin-top: 16px;\n}\n\n.portal-v2 .candidate-profile-badge-current {\n  margin: 16px 0;\n  display: inline-block;\n}\n\n.portal-v2 .candidate-profile-block--mt {\n  margin-top: 16px;\n}\n\n.portal-v2 .candidate-profile-upload-dropzone {\n  border: 2px dashed #9eb1cc;\n  text-align: center;\n  padding: 32px 16px;\n  margin-top: 8px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.portal-v2 .candidate-profile-upload-label {\n  cursor: pointer;\n  width: 100%;\n  display: block;\n}\n\n.portal-v2 .candidate-profile-upload-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.portal-v2 .candidate-profile-upload-copy {\n  margin: 0 0 8px;\n  color: var(--ink);\n}\n\n.portal-v2 .candidate-profile-upload-accent {\n  color: #1d4ed8;\n  font-weight: 700;\n}\n\n.portal-v2 .candidate-profile-upload-meta {\n  font-size: 12px;\n  margin: 0;\n}\n\n.portal-v2 .candidate-profile-upload-selected {\n  margin-top: 16px;\n  background-color: rgba(96, 165, 250, 0.12);\n  border: 1px solid rgba(96, 165, 250, 0.35);\n}\n\n.portal-v2 .candidate-profile-upload-selected-copy {\n  margin: 0 0 12px;\n  color: #1d4ed8;\n}\n\n.portal-v2 .candidate-profile-button-full {\n  width: 100%;\n}\n\n.portal-v2 .candidate-profile-spinner-sm {\n  width: 16px;\n  height: 16px;\n}\n\n.portal-v2 .candidate-profile-section-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.portal-v2 .candidate-profile-entry-card {\n  margin-bottom: 12px;\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.portal-v2 .candidate-profile-entry-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.portal-v2 .candidate-profile-entry-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-entry-col {\n  flex: 1;\n  min-width: 140px;\n}\n\n.portal-v2 .candidate-profile-action-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-entry-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.portal-v2 .candidate-profile-entry-content {\n  flex: 1;\n}\n\n.portal-v2 .candidate-profile-entry-title {\n  font-weight: 700;\n}\n\n.portal-v2 .candidate-profile-meta-xs {\n  font-size: 12px;\n}\n\n.portal-v2 .candidate-profile-entry-desc {\n  margin-top: 4px;\n  white-space: pre-line;\n}\n\n.portal-v2 .candidate-profile-btn-xs {\n  font-size: 12px;\n  padding: 4px 8px;\n}\n\n.portal-v2 .candidate-profile-btn-danger {\n  color: #dc2626;\n}\n\n.portal-v2 .candidate-profile-entry-add {\n  background-color: rgba(96, 165, 250, 0.12);\n  border: 1px solid rgba(96, 165, 250, 0.35);\n}\n\n.portal-v2 .candidate-profile-inline-label-muted {\n  font-size: 14px;\n  color: var(--muted);\n}\n\n.portal-v2 .candidate-profile-skill-card {\n  margin-bottom: 8px;\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.portal-v2 .candidate-profile-skill-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.portal-v2 .candidate-profile-inline-meta {\n  margin-left: 8px;\n  font-size: 12px;\n}\n\n.portal-v2 .candidate-profile-link-wrap {\n  margin-top: 4px;\n}\n\n.portal-v2 .candidate-profile-link-xs {\n  font-size: 12px;\n}\n\n.portal-v2 .candidate-profile-button-lg {\n  width: 100%;\n  font-size: 16px;\n  padding: 14px;\n}\n\n.portal-v2 .candidate-profile-block--mb {\n  margin-bottom: 12px;\n}\n\n.portal-v2 .candidate-profile-badge-inline {\n  margin: 8px 0;\n  display: inline-block;\n}\n\n.portal-v2 .candidate-profile-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.portal-v2 .candidate-profile-file-selected {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n@media (max-width: 960px) {\n  .portal-v2 .topbar {\n    padding: 10px 12px;\n  }\n\n  .portal-v2 .portal-v2-topbar {\n    grid-template-columns: auto 1fr auto;\n    gap: 8px;\n  }\n\n  .portal-v2 .portal-v2-search {\n    padding: 7px 9px;\n  }\n\n  .portal-v2 .sidebar {\n    box-shadow: 0 12px 30px rgba(8, 24, 72, 0.5);\n  }\n\n  .portal-v2 .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .portal-v2 .pagination-card__controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .portal-v2 .job-detail-main {\n    grid-column: span 3;\n  }\n\n  .portal-v2 .job-detail-action-row {\n    flex-direction: column;\n  }\n\n  .portal-v2 .candidate-profile-view-hero {\n    align-items: flex-start;\n  }\n\n  .portal-v2 .candidate-profile-layout {\n    gap: 16px;\n  }\n\n  .portal-v2 .candidate-profile-entry-head,\n  .portal-v2 .candidate-profile-skill-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.portal-v2 .sidebar__group-header {\n  color: var(--portal-muted, #64748b);\n}\n\n.portal-v2 .sidebar__group-header:hover {\n  background: var(--portal-surface-2, rgba(15, 23, 42, 0.04));\n  color: var(--portal-ink, #0f172a);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
